import React from 'react';
import PropTypes from 'prop-types';
import '../styles/Error.scss';

const Error = (props) => {
    return (
        <div className={`error ${props.className}`}>
            {props.children}
        </div>
    );
};

Error.propTypes = {
    className: PropTypes.string.isRequired,
};

Error.defaultProps = {
    className: ''
};

export default Error;
